import styles from '../../styles/components/layouts/withLayout.module.scss';
import { useEffect } from 'react';
import { Alert, Loader } from 'rsuite';

const withLayout = (WrappedComponent: React.ReactElement, loading?: boolean, error?: Error) => {
  useEffect(() => {
    // eslint-disable-line react-hooks/rules-of-hooks
    if (error) {
      console.error(error);
      Alert.error('エラーが発生しました');
    }
  }, [error]);

  return (
    <>
      <div className={styles.wrapper}>{WrappedComponent}</div>
      {loading && <Loader center />}
    </>
  );
};

export { withLayout };
